import type { ReactNode } from "react";

/** 把字串中「<數字> 小時」的數字部分加粗。 */
export function boldHours(text: string): ReactNode[] {
  return text.split(/(\d+\s*小時)/g).map((part, i) => {
    const m = part.match(/^(\d+)(\s*小時)$/);
    if (m)
      return (
        <span key={i}>
          <strong>{m[1]}</strong>
          {m[2]}
        </span>
      );
    return <span key={i}>{part}</span>;
  });
}
